import { useState, useEffect } from "react";
import { supabase } from "../services/supabase";
import { filterOverdueUsers } from "../utils/calculator";

export const useAppGlobalData = () => {
  const [allParticipants, setAllParticipants] = useState([]);
  const [sessions, setSessions] = useState([]);
  const [allUnpaidUsers, setAllUnpaidUsers] = useState([]);
  const [overdueUnpaidUsers, setOverdueUnpaidUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchGlobalData = async () => {
    try {
      const [participantsRes, sessionsRes] = await Promise.all([
        supabase.from("participants").select("*").order("name", { ascending: true }),
        supabase.from("sessions").select("created_by, *, session_participants(participant_id)").order("session_date", { ascending: false }),
      ]);

      if (participantsRes.data) setAllParticipants(participantsRes.data);
      if (sessionsRes.data) setSessions(sessionsRes.data);
    } catch (error) {
      console.error("Error fetching global data:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchUnpaidUsers = async () => {
    try {
      const { data } = await supabase
        .from("session_payments")
        .select(`
          id, session_id, amount_owed, has_paid,
          participant_id,
          participants(name, profile_image_url, linked_user_id),
          sessions!inner(id, session_name, session_date)
        `)
        .eq("has_paid", false);

      if (data) {
        setAllUnpaidUsers(data);
        setOverdueUnpaidUsers(filterOverdueUsers(data));
      }
    } catch (err) {
      console.error("Error fetching unpaid users", err);
    }
  };

  useEffect(() => {
    fetchGlobalData();
    fetchUnpaidUsers();

    const channel = supabase
      .channel("global-db-changes")
      .on("postgres_changes", { event: "*", schema: "public", table: "participants" }, fetchGlobalData)
      .on("postgres_changes", { event: "*", schema: "public", table: "sessions" }, fetchGlobalData)
      .on("postgres_changes", { event: "*", schema: "public", table: "session_participants" }, fetchGlobalData)
      .on("postgres_changes", { event: "*", schema: "public", table: "session_payments" }, () => { fetchUnpaidUsers(); fetchGlobalData(); })
      .subscribe();

    return () => supabase.removeChannel(channel);
  }, []);

  return {
    allParticipants,
    sessions,
    allUnpaidUsers,
    overdueUnpaidUsers,
    loading,
    refreshGlobalData: fetchGlobalData,
    refreshUnpaidUsers: fetchUnpaidUsers
  };
};
